import { render, staticRenderFns } from "./AdministracionActividad3.vue?vue&type=template&id=2322ab0e&"
import script from "./AdministracionActividad3.vue?vue&type=script&lang=js&"
export * from "./AdministracionActividad3.vue?vue&type=script&lang=js&"
import style0 from "./AdministracionActividad3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports